import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Title,
  Text,
  rem,
  Card,
  Center,
  SimpleGrid,
  useMantineTheme,
  Divider,
} from '@mantine/core';

import * as classes from './FeatureBlock.module.css';
import ButtonBlock from '../ButtonBlock';
import ICONS_MAP from './IconsMap';


function FeatureBlock({
  featuresSottotitolo,
  featuresTitolo,
  featuresButtons,
  featuresList,
  stile,
}) {
  const { colors } = useMantineTheme();

  return (
    <Container fluid style={{ backgroundColor: stile?.coloreDiSfondo ? colors[stile?.coloreDiSfondo][1] : 'inherit' }}>
      <Container p="md">
        {featuresTitolo && (
          <Title order={3} className={classes.title} ta="center" mt="sm">
            {featuresTitolo}
          </Title>
        )}

        {featuresSottotitolo && (
          <>
            <Text className={classes.description} ta="center" mt="md">
              {featuresSottotitolo}
            </Text>
            <Divider color={`${stile?.coloreDiSfondo ? stile?.coloreDiSfondo : 'secondary'}.7`} size="sm" mt="sm" className={classes.separator} />
          </>
        )}

        <Container p={0} pb="md">
          <SimpleGrid cols={{ base: 1, md: 3, xs: 2 }} spacing="xl" mt={50}>
            {featuresList.map(({
              bloccoFeatureTitolo,
              bloccoFeatureIcona,
              bloccoFeatureDescrizione
            }, key) => {
              const Ico = ICONS_MAP[bloccoFeatureIcona];

              return (
                <Card key={`feature_${key + 1}`} shadow="md" radius="md" className={classes.card} padding="xl">
                  {Ico && (
                    <Ico
                      style={{ width: rem(50), height: rem(50) }}
                      stroke={2}
                      color={colors[stile?.coloreDiSfondo][5] || colors.secondary[5]}
                    />
                  )}
                  <Text span fz="lg" fw={500} className={classes.cardTitle} mt="md">
                    {bloccoFeatureTitolo}
                    <Divider color={`${stile?.coloreDiSfondo ? stile?.coloreDiSfondo : 'secondary'}.7`} size="sm" mt="xs" className={classes.innerSeparator} />
                  </Text>
                  <Text fz="sm" c="gray.7" mt="sm">
                    {bloccoFeatureDescrizione}
                  </Text>
                </Card>
              );
            })}
          </SimpleGrid>
          {!!featuresButtons?.length && (
            <Center mt="md" mb="xl">
              <ButtonBlock buttons={featuresButtons} />
            </Center>
          )}
        </Container>
      </Container>
    </Container>
  );
}

FeatureBlock.propTypes = {
  featuresTitolo: PropTypes.string,
  featuresSottotitolo: PropTypes.string,
  featuresButtons: PropTypes.array,
  featuresList: PropTypes.array,
};

export default FeatureBlock;
